// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_container__3V-Ak","tip":"Payment_tip__JD8bB"};